export const getFeatureFlags = (state) => state.globalSettings.featureFlags;
export const getDefaultActiveRankTypes = (state) => state.globalSettings.defaultActiveRankTypes;
export const getProviderChanges = (state) => ({
  provider: state.globalSettings.provider,
  status: state.globalSettings.status,
  activeCountries: state.globalSettings.activeCountries,
});
